var $ = require('jquery');

$(function () {
    $('.material-icons--share').on('click', function (e) {
        e.preventDefault();
        $('body').toggleClass('show-share');
    })
});
